'use client'

import { useMutation } from '@tanstack/react-query'
import { useCallback } from 'react'
import {
    requestPasswordLinkByDocumentService,
    requestPasswordLinkByEmailService,
} from '~/services/domain/auth/PasswordService'

/**
 * Esqueci minha senha, por e-mail ou por CPF/CNPJ. Devolve o texto da API (com o e-mail mascarado quando foi pelo
 * documento); sucesso, erro e a ida para o login ficam com a tela (modais).
 */
export function useForgotPassword() {
    const linkMutation = useMutation({
        mutationFn: (request: { email: string } | { document: string }) =>
            'email' in request
                ? requestPasswordLinkByEmailService(request.email)
                : requestPasswordLinkByDocumentService(request.document),
    })

    const requestByEmail = useCallback(
        (email: string) => linkMutation.mutateAsync({ email }),
        [linkMutation.mutateAsync],
    )

    const requestByDocument = useCallback(
        (document: string) => linkMutation.mutateAsync({ document }),
        [linkMutation.mutateAsync],
    )

    return { requestByEmail, requestByDocument, isLoading: linkMutation.isPending }
}
